import {
  AutoComplete,
  Input,
  Tooltip,
  Breadcrumb,
  message,
  Select,
  DatePicker,
  Modal,
} from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import {
  EditIcon,
  DeleteIcon,
  DetailIcon,
  SearchIcon,
  AscRed,
  DescGrey,
  CloseIconSearch,
  DateIcon,
  DownloadIcon,
  RegenerateIcon,
} from "../../../asset";
import style from "./ReportLog.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";
import CustomHover from "../../../component/custom-hover/CustomHover";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";
import ModalRegenerate from "../../../component/modal/ModalRegenerate";
import SecondaryButton from "../../../component/button/SecondaryButton";
import RangeDatePicker from "../../../component/range-date-picker/RangeDatePicker";
import moment from "moment";
// import { DatePicker } from "antd";
const ReportLog = (props) => {
  const {RangePicker} = DatePicker;
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [sorting, setSorting] = useState("");
  const [sortingBy, setSortingBy] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsfilter] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [titleFailed, setTitleFailed] = useState("");
  const [messageFailed, setMessageFailed] = useState("");
  const [showGenerate, setShowGenerate] = useState(false);
  const [idGenerate, setIdGenerate] = useState()
  const [fromDate, setFromDate] = useState()
  const [toDate, setToDate] = useState()
  const [visible, setVisible] = useState(false)
  const fileType = [
    { value: "ALL", label: "All File Type" },
    { value: "PDF", label: "PDF" },
    { value: "CSV", label: "CSV" },
  ];
  const status = [
    { value: "ALL", label: "All Status" },
    { value: "On Process", label: "On Process" },
    { value: "Complete", label: "Complete" },
    { value: "Failed", label: "Failed" },
    { value: "Expired", label: "Expired" },
  ];
  const reportType = [
    { value: "ALL", label: "All Report Type" },
    { value: "Delivery Associate Report", label: "Delivery Associate Report" },
    { value: "Depot Report", label: "Depot Report" },
    { value: "Trip Report", label: "Trip Report" },
    { value: "Order Report", label: "Order Report" },
  ];
  const filterStatus = [
    { value: "ALL", label: "All Status" },
    { value: "On Process", label: "On Process" },
    { value: "Complete", label: "Complete" },
    { value: "Failed", label: "Failed" },
    { value: "Expired", label: "Expired" },
  ];

  const [filters, setFilters] = useState({
    report_type: "ALL",
    period_date: {
      filter: "Today",
      from_date: "",
      thru_date: "",
    },
    file_type: "ALL",
    status: "ALL",
  });

  const dates = [
    { value: "Today", label: "Today" },
    { value: "This Week", label: "This Week" },
    { value: "This Month", label: "This Month" },
    { value: "Last 3 Month", label: "Last 3 Month" },
    { value: "This Year", label: "This Year" },
    { value: "Custom Date", label: "Custom Date"
    // <RangeDatePicker
    //     //  styleDiv={`${style.RangePickerAdd} ${style.Panels}`}
    //     //  styleComponent={style.Panels}
    //      //   renderExtraFooter={() => <button>OK</button>}
    //      suffixIcon={""}
    //      separator=""
    //      style={{
    //        width: "100%"
    //      }}
    //      placeholder={['Custom Date', '']} 
    //      variant="borderless" 
    //     //  onChange={(value) => this.onChangeRangeDate(value)}
    //     //  value={[moment(fromDate), moment(toDate)]}
    //     //  onClick={this.onOpenDatePicker}
    //      open={filters?.period_date?.filter === "Custom Date"}
    //      format={"DD MMMM YYYY"}
    //      allowClear={false}
    //      renderExtraFooter={() => {
    //       //  let save = true;
    //       //  let tempParamDate = moment(fromDate)
    //       //    .add(
    //       //      90,
    //       //      "days"
    //       //    )
    //       //    .toISOString();
    //       //  if (moment(toDate).isSameOrBefore(tempParamDate)) {
    //       //    save = true;
    //       //  } else {
    //       //    save = false;
    //       //  }
    //        return (
    //          <div>
    //            <div style={{ flexDirection: "row" }}>
    //              {/* <ErrorMessage
    //                children={
    //                  save === false &&
    //                  this.props.t("COMMON:VALID_RANGE_DATE", {
    //                    len:90,
    //                  })
    //                }
    //              /> */}
    //            </div>
    //            <div style={{ display: "flex", justifyContent: "end" }}>
    //             <PrimaryButton
    //             text={t("Save")}/>
    //             <SecondaryButton
    //             text={t("Cancel")}/>
    //              {/* <ActionButtonDate
    //                border={`1px solid ${PRIMARY_COLOR}`}
    //                onClick={() => this.handleCancel()}
    //                backgroundColor={WHITE}
    //                color={PRIMARY_COLOR}
    //              >
    //                {this.props.t("COMMON:CANCEL")}
    //              </ActionButtonDate>
    //              <ActionButtonDate
    //                onClick={() => this.handleSaveDate()}
    //                backgroundColor={PRIMARY_COLOR}
    //                color={WHITE}
    //                disabled={!save}
    //              >
    //                {this.props.t("COMMON:SAVE")}
    //              </ActionButtonDate> */}
    //            </div>
    //          </div>
    //        );
    //      }}
    //    />},
  }
  ];
  // const [period, setPeriod] = useState({
  //   filter: "Today",
  //   from_date: "",
  //   thru_date: "",
  // });
  const dispatch = useDispatch();

  const handleChange = (value, name) => {
    if (name === "report_type") {
      setFilters((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "file_type") {
      setFilters((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "status") {
      setFilters((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    }else if (name === "period") {
      if(value === "Custom Date"){
        setVisible(true)
      }else{
      let periods ={
        filter: value,
        from_date: "",
        thru_date: "",
      }
      setFilters((prevsValue) => {
        return {
          ...prevsValue,
          ["period_date"]: periods,
        };
      });
    }
    }
  };
console.log("fil", filters);
  const doGet = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGetDownloadFile = async (endpoint, tkn, data) => {
    const url = GROLOG_ORDER_URL + endpoint;
    return axios({
            method: "POST",
            url: url,
            responseType: "arraybuffer",
            headers: { Authorization: tkn },
            data: data,
        });
  };

  const fetchData = async (data, sort, pages, sortBy) => {
    setLoading(true);
    let datas = {
      page: pages ? pages : page,
      limit: limit,
      order: `${sortBy?sortBy:sortingBy} ${sort?sort:sorting}`,
      filter: filter
        ? "file_name lk " + filter
        : data
        ? "file_name lk " + data
        : "",
      connector: "",
      other: filters
      // {
      //   report_type: "ALL",
      //   period_date: {
      //     filter: "Custom Date",
      //     from_date: "2024-04-12",
      //     thru_date: "2024-04-13",
      //   },
      //   file_type: "ALL",
      //   status: "ALL",
      // },
    };
    let res = await doGet(`/report/log-report`, token, datas);
    let init = await doGet(`/report/log-report/initiate`, token, datas);
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
    if (init?.data?.payload.data) {
      setInitiate(init?.data?.payload.data);
    } else {
    }
    setListData(res?.data?.payload?.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false);
  }, [page, limit, filter]);

  useEffect(()=>{
    fetchData()
  },[filters])

  useEffect(()=>{
    setFromDate(new Date())
    setToDate(new Date())
  },[])

  const handleEdit = (id) => {
    navigate(ROUTES.ADDITIONAL_PROOFS.EDIT, { state: id });
  };

  const handleDownload = async (id, filename) => {
    let datas = {
      id: id,
    };
    try{
    let res = await doGetDownloadFile(`/report/log-report/download`, token, datas);
    console.log("success", res, res?.data);
    setTimeout(() => {
      const url = window.URL.createObjectURL(new Blob([res?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}`);
      document.body.appendChild(link);
      setTimeout(link.click(), 2000);
      link.parentNode.removeChild(link);
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 128);

      setTimeout(
        () =>
          this.setState({
            modalProgress: false,
            progressExport: 0,
            modalAlertExport: true,
          }),
        1000
      );
    }, 256);
    }catch(err){
      setTitleFailed("Data can't be downloaded")
      setMessageFailed(err?.response?.data?.payload?.message)
      setFailedModalOpen(true)
    }
  };

  const handleGenerate = async (id, filename) => {
    let datas = {
      id: id,
    };
    try{
    let res = await doGet(`/report/log-report/regenerate`, token, datas);
    setShowGenerate(false)
    fetchData()
    console.log("res");
    }catch(err){
      console.log("error",err);
      setShowGenerate(true)
      setTitleFailed("Data can't be generated")
      setMessageFailed(err?.response?.data?.payload?.message)
      setFailedModalOpen(true)
    }
  };

  const onGenerate = (id) =>{
    setIdGenerate(id)
    setShowGenerate(true)
  }

  const handleDetail = (id) => {
    navigate(ROUTES.ADDITIONAL_PROOFS.DETAIL, { state: id });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const dataSource = listData
    ? listData.map((result) => ({
        reportType: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.report_type}
          </span>
        ),

        fileName: (
        <CustomHover limit={15} value={result?.file_name}/>
        ),
        date: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.date}
          </span>
        ),
        fileType: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.file_type}
          </span>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.status}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("Download")} color="#CF0000">
              <button onClick={() => handleDownload(result?.id, result?.file_name)}>
                <img src={DownloadIcon} alt="edit" />
              </button>
            </Tooltip>
            <Tooltip title={t("Regenerate")} color="#CF0000">
              <button onClick={() => onGenerate(result?.id, result?.file_name)}>
                <img src={RegenerateIcon} alt="del" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const doSort = async (sort, sortBy) => {
    await setSortingBy(sortBy)
    await setSorting(sort);
    if (sort && sortBy) {
    await setSorting(sort);
    await setSortingBy(sortBy)
    fetchData("", sort, 1, sortBy);
    }
  };

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Report Type")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="report_type" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="report_type" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "report_type");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="report_type" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="report_type" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "report_type");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "reportType",
      key: "reportType",
      // sorter: {
      //   compare: (a, b) => a.reportType.localeCompare(b.reportType),
      // },
      render: (reportType) => <span>{reportType}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("File Name")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="file_name" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="file_name" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "file_name");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="file_name" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="file_name" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "file_name");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "fileName",
      key: "fileName",
      render: (fileName) => <span>{fileName}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Date")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="date" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="date" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "date");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="date" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="date" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "date");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "date",
      key: "date",
      render: (date) => <span>{date}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("File Type")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="file_type" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="file_type" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "file_type");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="file_type" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="file_type" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "file_type");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "fileType",
      key: "fileType",
      render: (fileType) => <span>{fileType}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Status")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="status" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="status" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "status");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="status" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="status" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "status");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];
  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filterss,
    mapping_principal_id
  ) => {
    if (filterss?.length >= 1) {
      let datas = {
        page: 1,
        limit: 10,
        order: "",
        filter: `file_name lk ${filterss}`,
        connector: "",
        other: filters
        // {
        //   report_type: "ALL",
        //   period_date: {
        //     filter: "Custom Date",
        //     from_date: "2024-04-10",
        //     thru_date: "2024-04-15",
        //   },
        //   file_type: "ALL",
        //   status: "ALL",
        // },
      };
      let res = await doGet(`/report/log-report/search`, token, datas);
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = (value) => {
    setSearchRecommedation(value);
    setIsfilter(true);
    if (value?.length >= 3) {
      setListRecommendation([]);
      setSearchRecommedation(value);
      fetchRecommendation(1, 10, value);
    } else if (!value) {
      setListRecommendation([]);
      setIsfilter(false);
      setFilter(null);
      fetchData("", sorting, 1);
    } else {
      setListRecommendation([]);
      setIsfilter(false);
      setFilter(null);
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data);
    fetchData(data, sorting, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);

    fetchData("", sorting, 1);
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

    const handleFailedModal = () =>{
      setTitleFailed("")
      setMessageFailed("")
      setFailedModalOpen(false)
    }

  return (
    <>
      <ModalRegenerate
        act = {()=>handleGenerate(idGenerate)}
        visible={showGenerate}
        action={() => setShowGenerate(false)}
      />

      <ModalFailedDelete
        show={failedModalOpen}
        action={() => handleFailedModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title={titleFailed}
        description={messageFailed}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={2}
          menuLevel1={`Report`}
          menuLevel2={`Log Report`}
        />

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Log Report")}
        </h1>

        <div className={style.headerContainer + " flex mr-2"}>
          <AutoComplete
            options={listRecommendation?.map((item) => ({
              value: item?.value,
              label: item?.value,
            }))}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(value) => onSelectRecommendation(value)}
          >
            <Input
              placeholder={t("Search By File Name")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={filter ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={filter ? () => onClearRecommendation() : null}
                />
              }
              // options={options}
              value={searchRecommendation}
              // onChange={(value) => onSearchRecommendation(value)}
            />
          </AutoComplete>

          <Select
            className="w-[200px] ml-2"
            dropdownStyle={{
              backgroundColor: "white",
            }}
            size="large"
            value={filters?.report_type}
            onChange={(value) => handleChange(value, "report_type")}
            options={reportType}
          />
          <Select
            className="w-[300px] ml-2"
            dropdownStyle={{
              backgroundColor: "white",
            }}
            size="large"
            value={filters?.period_date?.filter}
            onChange={(value) => handleChange(value, "period")}
            options={dates}
            suffixIcon={<img src={DateIcon} alt="date" />}
            />
            <Modal
        open={visible}
        // width={"350px"}
                width={650}
        // className="h-[400px]"
        onCancel={() => setVisible(false)}
        footer={
                   <div>
               <div style={{ flexDirection: "row" }}>
                 {/* <ErrorMessage
                   children={
                     save === false &&
                     this.props.t("COMMON:VALID_RANGE_DATE", {
                       len:90,
                     })
                   }
                 /> */}
               </div>
               <div style={{ display: "flex", justifyContent: "end", margin:"3px" }}>
                <PrimaryButton
                styles={" mr-2"}
                text={t("Save")}/>
                <SecondaryButton
                action={()=>setVisible(false)}
                text={t("Cancel")}/>
               </div>
             </div>
    //        );
        }
      >
        <div className="w-[700px] h-96">
        <RangePicker className={style.datePicker} defaultOpen={visible}   showTime={false}/>
        </div>
      </Modal>
            {/* <RangeDatePicker variant={"borderless"} defaultOpen={true} showTime={false} /> */}
            <Select
              className="w-[200px] ml-2"
              dropdownStyle={{
                backgroundColor: "white",
              }}
              size="large"
              value={filters?.file_type}
              onChange={(value) => handleChange(value, "file_type")}
              options={fileType}
            />
            <Select
              className="w-[200px] ml-2"
              dropdownStyle={{
                backgroundColor: "white",
              }}
              size="large"
              value={filters?.status}
              onChange={(value) => handleChange(value, "status")}
              options={filterStatus}
            />
          {/* <Link to={ROUTES.ADDITIONAL_PROOFS.ADD}>
            <PrimaryButton
              text={t("Add Additional Proofs")}
              prefixIcon={<AddIcon />}
            />
          </Link> */}
        </div>

        {!loading ? (
          <div className={style.tableContainer}>
            <CustomTable columns={ListColumn} data={dataSource} />
            <div className={style.containerPagination + " mt-[-45px]"}>
              <CustomPaging
                idLimit="ddlrowsperpagemustselllist"
                idPagination="btnpaginationmustselllist"
                size="small"
                current={page}
                defaultCurrent={page}
                pageSize={limit}
                total={initiate && initiate?.count_data}
                pageSizeOptions={initiate && initiate?.valid_limit}
                onShowSizeChange={() => handlePagination()}
                handlePaging={(a, b) => handlePagination(a, b)}
                title={t("COMMON:ROW_PAGE")}
              />
            </div>
          </div>
        ) : (
          "...loading"
        )}
      </div>
    </>
  );
};

export default ReportLog;
